export const getElementHeight = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return 0;
  const { height } = el.getBoundingClientRect();
  return height;
};